import { useState, useEffect, useCallback } from "react";
import type { ProductQuery } from "../../../__generated__/graphql";

type Product = ProductQuery["product"];

export function useProductQuantity(product: Product | null | undefined) {
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (product?.currentCount === 0) {
      setQuantity(0);
    }
  }, [product?.currentCount]);

  const increaseQuantity = useCallback(() => {
    if (product && quantity < product.currentCount) {
      setQuantity((q) => q + 1);
    }
  }, [product, quantity]);

  const decreaseQuantity = useCallback(() => {
    if (quantity > 1) {
      setQuantity((q) => q - 1);
    }
  }, [quantity]);

  return { quantity, increaseQuantity, decreaseQuantity };
}
